/** Read-only Freistellungsbescheinigung inside Kontaktdaten (PersonData) on the person view page. */
function initTaxExemptionViewSection() {
  const currentContactId =
    window.location.pathname.match(/\/persons\/view-person\/(\d+)/)?.[1] ||
    window.location.pathname.match(/\/view-person\/(\d+)/)?.[1]
  if (!currentContactId) {
    return false
  }

  const personData = document.querySelector('.PersonData')
  if (!personData) {
    return false
  }

  const existingSection = document.querySelector('[data-impowerx-view-tax-exemption="true"]')
  if (existingSection) {
    if (existingSection._contactId === currentContactId && document.body.contains(existingSection)) {
      return true
    }
    existingSection.remove()
  }

  const formatDate = (value) => {
    if (!value) {
      return 'Nicht gesetzt'
    }
    const parsedDate = new Date(value)
    if (Number.isNaN(parsedDate.getTime())) {
      return 'Nicht gesetzt'
    }
    const day = String(parsedDate.getDate()).padStart(2, '0')
    const month = String(parsedDate.getMonth() + 1).padStart(2, '0')
    const year = parsedDate.getFullYear()
    return `${day}.${month}.${year}`
  }

  const toLocalDateOnly = (value) => {
    if (!value) {
      return null
    }
    const parsed = new Date(value)
    if (Number.isNaN(parsed.getTime())) {
      return null
    }
    return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate())
  }

  const computeStatus = (validityFrom, validityTo) => {
    const from = toLocalDateOnly(validityFrom)
    const to = toLocalDateOnly(validityTo)
    if (!from || !to) {
      return '—'
    }
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    if (today < from) {
      return 'Noch nicht gültig'
    }
    if (today > to) {
      return 'Abgelaufen'
    }
    return 'Aktiv'
  }

  const section = document.createElement('div')
  section.className = 'impowerx-tax-exemption-view'
  section.dataset.impowerxViewTaxExemption = 'true'
  section._contactId = currentContactId
  section.innerHTML = `
    <style data-field-name="viewTaxExemptionStyle">
      .impowerx-tax-exemption-view {
        margin-top: 16px;
        width: 100%;
      }
      .impowerx-tax-exemption-view-heading {
        font-size: 12px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.45);
        text-transform: uppercase;
        margin-bottom: 8px;
      }
      .impowerx-tax-exemption-view-content {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        row-gap: 6px;
      }
      .impowerx-tax-exemption-view-item {
        box-sizing: border-box;
        flex: 0 0 calc((100% - 32px) / 3);
        max-width: calc((100% - 32px) / 3);
        min-width: 8rem;
      }
      .impowerx-tax-exemption-view-value {
        word-break: break-word;
      }
    </style>
    <div class="impowerx-tax-exemption-view-heading">Freistellungsbescheinigung</div>
    <div class="impowerx-tax-exemption-view-content">
      <div class="basic-info section impowerx-tax-exemption-view-item">
        <div class="label">Gültig von</div>
        <div class="value impowerx-tax-exemption-view-value" data-field-name="taxExemptionFromValue">Lade...</div>
      </div>
      <div class="basic-info section impowerx-tax-exemption-view-item">
        <div class="label">Gültig bis</div>
        <div class="value impowerx-tax-exemption-view-value" data-field-name="taxExemptionToValue">Lade...</div>
      </div>
      <div class="basic-info section impowerx-tax-exemption-view-item">
        <div class="label">Status</div>
        <div class="value impowerx-tax-exemption-view-value" data-field-name="taxExemptionStatusValue">Lade...</div>
      </div>
    </div>
  `

  personData.appendChild(section)

  const fromEl = section.querySelector('[data-field-name="taxExemptionFromValue"]')
  const toEl = section.querySelector('[data-field-name="taxExemptionToValue"]')
  const statusEl = section.querySelector('[data-field-name="taxExemptionStatusValue"]')

  const setFields = (fromLabel, toLabel, statusLabel) => {
    if (fromEl) fromEl.textContent = fromLabel
    if (toEl) toEl.textContent = toLabel
    if (statusEl) statusEl.textContent = statusLabel
  }

  ;(async () => {
    try {
      const authData = JSON.parse(localStorage.getItem('auth') || '{}')
      const token = authData.token
      if (!token) {
        if (document.body.contains(section)) {
          setFields('Nicht verfügbar', 'Nicht verfügbar', 'Nicht verfügbar')
        }
        return
      }

      const res = await fetch(
        `${baseApiUrl}/api/impowerX/contacts/tax-exemption/contact/${currentContactId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      )

      if (!document.body.contains(section) || section._contactId !== currentContactId) {
        return
      }

      if (!res.ok) {
        setFields('Fehler beim Laden', 'Fehler beim Laden', 'Fehler beim Laden')
        return
      }

      const data = await res.json()
      const taxExemption = data?.taxExemption

      if (!taxExemption || taxExemption.isDeleted) {
        // Keep a hidden sentinel so MutationObserver does not remount/refetch.
        section.style.display = 'none'
        section._empty = true
        return
      }

      setFields(
        formatDate(taxExemption.validityFrom),
        formatDate(taxExemption.validityTo),
        computeStatus(taxExemption.validityFrom, taxExemption.validityTo)
      )
    } catch (error) {
      if (document.body.contains(section) && section._contactId === currentContactId) {
        setFields('Fehler beim Laden', 'Fehler beim Laden', 'Fehler beim Laden')
      }
    }
  })()

  return true
}
